function bindForm(){
  document.getElementById("closeButton").addEventListener("click", e=>{
  	closePopup();
  });
                                                          
  let formSelector = '#nlPopupForm';
  let nlPopupForm = {
    'nlPopEmail': {'required': true},
    'birthday': {'required': true},
    'gender': {'required': true},
    'nlPopPrivacy': {'required': true},
    'nlPopOtpStat': {'required': false},
    'nlPopOtpProfiling': {'required': false}
  };

  nlPopupForm = new FormController(formSelector, nlPopupForm, document.querySelector("#sendMailPopUp"), "https://contacts.moma.it/"+localeForm+"/mail.mngr",
  //nlPopupForm = new FormController(formSelector, nlPopupForm, document.querySelector("#sendMailPopUp"), "https://scdn.moma.it/salesforce/mailmgr.php",
  {
    successPopupId: 'newsletterConfirmed',
    callbacks:{
      success : function(){
      	closePopup();
        bindSetUserInfo();
      }
    }
  });
  
}

let cookieName = "nlCookie";
document.addEventListener("DOMContentLoaded", e=>{
  bindNewsletter();
});

function bindNewsletter(){
  let nlCookie = getCookieNl(cookieName);
  let buttonClass = "customBtn colorBlack bgColorLightblue hoverBgColorBlack hoverColorWhite";
  if(type == "blackfriday"){
    buttonClass = "customBtn bgColorWhite hoverBgColorLightblue colorBlack hoverColorBlack mr-3";
    
  }
  
  if (nlCookie == "") {
    let popup = "<div id='nlPopUp' class='hide " + type + "'>"+
      "<span id='closeButton'>x</span>"+
      "<img id='nlLogo' src='"+ logo +"' />" +
      "<div class='textWrapper'>"+
        "<h2 style='text-align:center;' class='titleLev5 text-uppercase colorBlack'>"+title+"</h2>"+
        "<p style='text-align:center; margin-top: 0;'>"+paragraph+"</p>"+
        "<form id='nlPopupForm' class='myForm'>"+
          "<input type='hidden' name='idLingua' value='"+idLingua+"'>"+
          "<input type='hidden' name='command' value='newsletter_handler'>"+
          "<label for='nlPopEmail'>E-mail<span class='mandatoryMarker'>*</span></label>"+
          "<input required='required' autocomplete='off' class='form-control mb-3' id='nlPopEmail' name='email' type='text' placeholder='E-mail' required data-cons-subject='email' >"+
          "<label for='birthday'>"+birthday+"<span class='mandatoryMarker'>*</span></label>"+
          "<input required='required' id='birthday' class='Form__Input' name='birthday' type='date'>"+
          "<label id='genderLabel' for='gender'>"+gender+"<span class='mandatoryMarker'>*</span></label>"+
          "<div class='customRadio'>"+
            "<input type='radio' style='display: none;' id='gender' name='gender' value='1'>"+
            "<label for='gender'>"+
              "<span class='fakeCheck'></span>"+genderUomo+""+
            "</label>"+
          "</div>"+
          "<div class='customRadio'>"+
            "<input type='radio' style='display: none;' id='type-2' name='gender' value='2'>"+
            "<label for='type-2'>"+
              "<span class='fakeCheck'></span>"+genderDonna+""+
            "</label>"+
          "</div>"+
          "<div class='customRadio'>"+
            "<input type='radio' style='display: none;' id='type-3' name='gender' value='3'>"+
            "<label for='type-3'>"+
              "<span class='fakeCheck'></span>"+genderNan+""+
            "</label>"+
          "</div>"+
          "<div class='privacyContentBlock mt-3'>"+
            "<p class='mb-2'>"+privacy_description+"</p>"+
            "<div class='flatcustomCheckbox customCheckbox'>"+
              "<input type='checkbox' class='d-none' id='nlPopPrivacy' name='privacy[main]' required='required' data-cons-preference='privacy'>"+
              "<label id='privacyLabel' for='nlPopPrivacy'>"+check1+"<span class='fakeCheck'></span><span class='mandatoryMarker'>*</span></label>"+
            "</div>"+
            "<div class='flatcustomCheckbox customCheckbox'>"+
              "<input type='checkbox' class='d-none' id='nlPopOtpStat' name='privacy[statistics]' data-cons-preference='statistics'>" +
    		  "<label for='nlPopOtpStat'>"+check2+"<span class='fakeCheck'></span></label>"+
            "</div>"+
            "<div class='flatcustomCheckbox customCheckbox'>"+
        	"<input type='checkbox' class='d-none' id='nlPopOtpProfiling' name='privacy[profiling]' data-cons-preference='profiling'>" +
              "<label for='nlPopOtpProfiling'>"+check3+"<span class='fakeCheck'></span></label>"+
            "</div>"+
          "</div>"+
           "<div class=\"mt-1\">"+
             "<span class=\"checkAllChecks\" data-form=\"#nlPopupForm\">"+
               "<div class=\"check d-inline-block\">"+
                 "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"15.208\" viewBox=\"0 0 20 15.208\">"+
                   "<path id=\"Icon_ionic-md-checkmark\" data-name=\"Icon ionic-md-checkmark\" d=\"M10.87,19.708,6.167,15,4.5,16.587l6.37,6.356L24.5,9.323,22.833,7.734Z\" transform=\"translate(-4.5 -7.734)\"></path>"+
                 "</svg>"+
               "</div>"+selectAll+
             "</span>"+
           "</div>"+
          "<div class='mt-3 text-center'>"+
           "<span data-form='#nlPopupForm' class='d-inline-block " + buttonClass + "' id='sendMailPopUp'>"+subscribePopup+"</span>"+
          "</div>"+
        "</form>"+
      "</div>"+
    "</div>";

    var div = document.createElement('div');
    div.innerHTML = popup.trim();

    document.body.appendChild(div.firstChild);
    setTimeout(function(){
      document.getElementById("nlPopUp").classList.remove("hide");
    }, 500);
    bindForm();
    //bindPopUpEvents();
  }
}

function closePopup(){
  setCookie(cookieName, "1", "1095");
  let nlPopUp = document.getElementById("nlPopUp");
  nlPopUp.classList.add("hide");
  setTimeout(function(){
    nlPopUp.remove();
  }, 500);
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookieNl(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function createCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


/*document.querySelector("#customer_login .Form__Submit").addEventListener("click", e=>{
  	let form = document.getElementById("customer_login");
	e.preventDefault();
  	e.stopPropagation();
});*/

function bindSetUserInfo(){
  if(accepted && controlEmail != null && controlProfiling == true){
    _etmc.push(["setOrgId", "536000833"]);
    _etmc.push(["setUserInfo", {"email": controlEmail }]);
    _etmc.push(["trackPageView"]);
  }  
}









             

















